// ──────────────────────────────────────────────────────────────────────────
// LE ISOLE DEL TELEFONO
//
// Sul telefono la barra in basso e la fascia in cima non toccano i bordi:
// sono due isole che galleggiano sopra la pagina, staccate di un dito dai
// lati, come le barre di iOS. Qui stanno le misure che servono anche a chi
// ci appoggia sopra qualcosa (la barra delle date, quella degli allievi e
// del quaderno), così se l'isola cambia altezza la seguono tutte.
// ──────────────────────────────────────────────────────────────────────────

// quanto sono staccate dai lati dello schermo: lo stesso margine delle barre
// che ci stanno sopra, così i bordi cadono uno sull'altro
export const PHONE_ISLAND_SIDE = "1rem"

// la barra in basso: quanto è alta, e quanto sta staccata l'isola del
// profilo da quella delle voci
export const PHONE_NAV_HEIGHT = "4.25rem"
export const PHONE_ISLANDS_GAP = "0.625rem"

// Quanto sta sollevata dal fondo. Sugli iPhone senza tasto c'è la riga della
// home: l'isola le sta appena sopra, come fa iOS, senza lasciarle tutto il
// suo spazio. Dove quella riga non c'è resta comunque un po' d'aria.
export const PHONE_NAV_BOTTOM = "max(0.75rem, calc(env(safe-area-inset-bottom) - 0.625rem))"

// dove si appoggia una barra che sta sopra l'isola
export const ABOVE_PHONE_NAV = `calc(${PHONE_NAV_BOTTOM} + ${PHONE_NAV_HEIGHT} + 0.75rem)`

// la fascia in cima: quanto è alta, e quanto sta sotto l'orlo dello schermo
export const PHONE_HEADER_HEIGHT = "3.75rem"
export const PHONE_HEADER_TOP = "calc(env(safe-area-inset-top) + 0.375rem)"
